module.exports = __webpack_public_path__ + "img/about_img04.d1e2ed9b.png";